import WarrantiesContent from "./WarrantiesContent";

export default WarrantiesContent;
